import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { AlternateShippingAddressData } from '../../../../../../models/order/workflow/alternate-shipping-address.model';


@Injectable({ providedIn: 'root' })
export class AlternateShippingAddressStateService extends BaseWorkflowStateService<AlternateShippingAddressData> {
    override stateKey: string = 'alternateShippingAddress';
}